import "../../node_modules/react-grid-layout/css/styles.css";
import "../../node_modules/react-resizable/css/styles.css";
import { GridLayout, Responsive, WidthProvider } from "react-grid-layout";
const ResponsiveGridLayout = WidthProvider(Responsive);

const Grid = ({ children, cols = 12, rowHeight = 30, width = 1200 }) => {
  return (
    <GridLayout
      className="layout"
      cols={cols}
      rowHeight={rowHeight}
      width={width}
    >
      {children}
    </GridLayout>
  );
};

const ResponsiveGrid = ({
  children,
  breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  cols = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
}) => {
  return (
    <ResponsiveGridLayout
      className="layout"
      cols={cols}
      breakpoints={breakpoints}
    >
      {children}
    </ResponsiveGridLayout>
  );
};

export { Grid, ResponsiveGrid };
